const doc = [({"da":({"models":({"option_position":({"coordinates_already_taken":"Koordinaterne er allerede brugt"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;